// extracted by mini-css-extract-plugin
export default {"cadreApropos":"Apropos_cadreApropos__DpkRC","sectionCollapses":"Apropos_sectionCollapses__xAuWV","lesBlocs":"Apropos_lesBlocs__HFp0+"};